var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client_download_url)?_c('a',{staticClass:"cpt-client-download-a",attrs:{"href":_vm.client_download_url,"download":"chat_installer.exe"},on:{"click":_vm.handleDownloadClient}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-download"},[_c('i',{staticClass:"iconfont icon-top-bold"}),_c('span',[_vm._v("下载客户端")])])
}]

export { render, staticRenderFns }